import React from 'react';

const BgLeftImage = () => (
  <div
    className="reg-page__secondary"
    style={{ backgroundImage: `url(https://cdn40.thomasnet.com/img40/bg-signin.jpg)` }}
  >
    <a style={{ display: 'flex', justifyContent: 'center' }} href="https://thomasnet.com">
      <img
        className="bg-image-logo"
        src="https://cdn40.thomasnet.com/img40/thomas-logo-blue.svg"
        alt="Thomas Logo"
      />
    </a>

    <p className="bg-image-text">
      
      <br />
      <br />
    </p>
  </div>
);

export default BgLeftImage;
